


<div class="email-app card-margin">
  <div class="email-desc-wrapper ml-auto" style=" font-size:13px;">
    <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
      <tbody>
        <tr style="border-bottom: 1px solid #dee2e6;" ><td  style="font-size:16px; font-weight: bold;padding: 5px 10px; text-align: center;"  colspan="3"> Transmittal Template</td></tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px;border-left: 1px solid #dee2e6;">Logo</td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; text-align: right;" colspan="4"><p>Larsen and Toubro Limited
            <p>Heavy Civil Infrastructure IC</p>
            <p>76 Amarsons Garden, Bhulabai Desai Marg</p>
            <p>Breach Candy, Mumbai - 400 026</p></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;" colspan="3"><b>TO :</b><span class="eip-ml-10" [innerHtml]="to"></span></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;" colspan="3"><b>Attention :</b> <span class="eip-ml-10"> {{attention}}</span></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Project :</b> <span class="eip-ml-10"> {{projName}}</span></td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Transmittal Number :</b> <span class="eip-ml-10"> {{message_No}}</span></td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Sheet No. :</b> <span class="eip-ml-10"> 1 of 1</span></td>
        </tr>
      </tbody>
    </table>
    <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
      <tbody>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;" rowspan="4"><b>Component :</b><span class="eip-ml-10">{{subject}}</span></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Date :</b> <span class="eip-ml-10" [innerHtml]="getDatePart('date')"></span></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Month :</b> <span class="eip-ml-10" [innerHtml]="getDatePart('month')"></span></td>
        </tr>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Year :</b> <span class="eip-ml-10" [innerHtml]="getDatePart('year')"></span></td>
        </tr>
      </tbody>
    </table>
    <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
      <thead style="background: #1063a1; color: white; border-bottom: 2px solid #dee2e6;">
        <tr style="border-bottom: 1px solid #dee2e6;">
          <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;">Sl. No.</th>
          <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Document/Drawing No.</th>
          <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Description</th>
          <th scope="col" style="padding: 5px 10px; border-right: 1px solid #dee2e6;">Revision No.</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let doc of docDetails;let i=index" style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;">{{i+1}}</td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;">{{doc.doc_No}}</td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;">{{doc.doc_Title}}</td>
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;">{{doc.revision_No}}</td>
        </tr>
      </tbody>
    </table>
    <table style="margin-top:10px">
      <tbody>
        <tr>
          <td><b>Medium Of Drawing :</b>
            <table style="border: 1px solid #dee2e6;margin-bottom:10px; margin-top:10px; width:100%">
              <tbody>
                <tr style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;  border-left: 1px solid #dee2e6;"><input type="checkbox" name="printedpaper" value="Bike">
                    <label for="printedpaper" style="margin-left: 5px;"> Printed Paper</label></td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6;  font-weight: bold;"><input type="checkbox" name="electcopy" value="Bike">
                    <label for="electcopy" style="margin-left: 5px;"> Elect Copy</label></td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;" rowspan="3">
                    <p>Size Copies / Sets</p>
                    <table style="border: 1px solid #dee2e6;margin-bottom:10px; margin-top:10px; width:100%">
                    <tbody>
                      <tr style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
                        <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;  border-left: 1px solid #dee2e6;">
                        A1 -1
                        </td>
                      </tr>
                      <tr style="background-color: #f2f0f0;">
                        <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;  border-left: 1px solid #dee2e6;">
                        A3 -3
                        </td>
                      </tr>
                    </tbody>
                  </table></td>
                </tr>
                <tr style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;  border-left: 1px solid #dee2e6;"><input type="checkbox" name="tracing" value="Bike">
                    <label for="tracing" style="margin-left: 5px;"> Tracing</label></td>
                    <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;  border-left: 1px solid #dee2e6;"><input type="checkbox" name="photocopy" value="Bike">
                      <label for="photocopy" style="margin-left: 5px;"> Photo Copy</label></td>
                   </tr>
              </tbody>
            </table>
          </td>

        </tr>
        <tr>
          <td><b>Purpose of Issuance :</b>
            <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
              <tbody>
                <tr style="background-color: #f2f0f0; border-bottom: 1px solid #dee2e6;">
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">AB - As Build</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FI - For Information</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FR - For Review</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">P - Preliminary</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FA - For Approval</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FR - For Record</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FT - For Tender</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">R - Replacement</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold;">FC - For Construction</td>
                  <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; font-weight: bold; background-color: #a7d4f6;">FC - For Construction</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="margin-top:10px">
      <p><b>Remarks :</b> <span></span></p>
    </div>
    <table style="border: 1px solid #dee2e6; margin-top:10px; width:100%">
      <tbody>
        <tr style="border-bottom: 1px solid #dee2e6;">
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Issued by :</b><span class="eip-ml-10">Submission of Construction Reference Drawings of Pile</span></td>
        
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Received By :</b> <span class="eip-ml-10"> {{date}}</span></td>
        
          <td style="padding: 5px 10px; border-right: 1px solid #dee2e6; border-left: 1px solid #dee2e6;"><b>Date :</b> <span class="eip-ml-10"> {{edrcRef}}</span></td>
        </tr>
      <tr>
        <p style="margin-top: 20px; padding-left: 10px;"><b>Project Manager</b></p>
        <p style="padding-left: 10px;"><b>L&T Construction</b></p>
      </tr>
      <tr>
        <p style="margin-top: 20px; padding-left: 10px;"><b>Cc: Chief Engineer, MCGM, Mumbai Coastal Road</b></p>
        <p style="padding-left: 10px;"><b>AECOM (GC)</b></p>
      </tr>
      <tr>
        <p style="margin-top: 20px; padding-left: 10px;">Encl. <b>As above</b></p>
      </tr>
      <tr>
        <p style="margin-top: 20px; padding-left: 10px; padding-bottom: 10px;">Prepared by - L&T Construction</p>
      </tr>
      </tbody>
    </table>
  </div>
</div>